/**
 * Created by user on 2019/3/20.
 */
export { getCjkName } from './conv';
export { zhDictCompare } from './sort';

export default exports as typeof import('./index');
